/* eslint-disable max-len */
import React from 'react';
function DateDictionary() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M17.7778 16.7222L13.5556 12.5V9.14333C14.78 8.7 15.6667 7.53889 15.6667 6.16667C15.6667 4.41444 14.2522 3 12.5 3C10.7478 3 9.33333 4.41444 9.33333 6.16667C9.33333 7.53889 10.22 8.7 11.4444 9.14333V12.5L7.22222 16.7222H3V22H8.27778V18.7806L12.5 14.3472L16.7222 18.7806V22H22V16.7222H17.7778Z" })));
}
export default DateDictionary;
